import { createStore, compose, applyMiddleware } from "redux";
import { reducers } from "./../reducers/index";
import thunk from "redux-thunk";
import { getAllCourses } from "./../actions/courses";

export const store = createStore(
    reducers,

    applyMiddleware(thunk)

);

//Initialize
store.dispatch(getAllCourses());

//subscribe
//store.subscribe(() => console.log(store.getState()));
